const accountUpdateFormCopyText = {
  cancelButtonLabel: 'Cancel',
  inputPlaceholder_name: 'Name',
  saveButtonLabel: 'Save'
};

export default accountUpdateFormCopyText;
